// extracted by mini-css-extract-plugin
export default {"styleLessButton":"vi","hoverOverlay":"wi","fadeIn":"xi","isHovered":"yi"};